import { render, staticRenderFns } from "./RegisterButtons.vue?vue&type=template&id=e572afda&scoped=true&"
import script from "./RegisterButtons.vue?vue&type=script&lang=js&"
export * from "./RegisterButtons.vue?vue&type=script&lang=js&"
import style0 from "./RegisterButtons.vue?vue&type=style&index=0&id=e572afda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e572afda",
  null
  
)

export default component.exports